module.exports = __webpack_public_path__ + "static/media/golf-carousel-2-1024x1366.11f235b0.jpg";